import { Button, CounterBadge, mergeClasses, PopoverTrigger } from "@fluentui/react-components";
import { memo } from "react";
import { EllipsisTooltip } from "../../../components/EllipsisTooltip/EllipsisTooltip";
import { useGenericPopoverPanelStyles } from "../styles/GenericPopoverPanel.styles";

type GenericPopoverPanelProps = {
  content: string;
  isOpen: boolean;
  count: number;
  icon: React.ReactNode;
};

export const GenericPopoverPanel = memo(({ content, isOpen, count, icon }: GenericPopoverPanelProps) => {
  const styles = useGenericPopoverPanelStyles();
  return (
    <PopoverTrigger disableButtonEnhancement>
      <Button
        appearance={"transparent"}
        icon={
          <EllipsisTooltip content={content} positioning={{ align: "center", offset: 4 }}>
            <span className={styles.iconStyle}>
              {!isOpen && count !== 0 && (
                <CounterBadge
                  iconPosition="after"
                  count={count}
                  size="small"
                  appearance="filled"
                  className={styles.popOverTriggerBadge}
                  color="brand"
                  shape="circular"
                />
              )}
              {icon}
            </span>
          </EllipsisTooltip>
        }
        className={mergeClasses(styles.popOverTrigger, isOpen ? styles.popOverTriggerActive : "")}
      ></Button>
    </PopoverTrigger>
  );
});
